module.exports = __webpack_public_path__ + "e20f4273122c94d5a39e9aaf47d120c5.png";